import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IBanner } from "../../../models/banner/response";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import { getBooleanStatus } from "../../../models/city/enum";
import { getUserStatusColor } from "../../../models/user/enum";
import Tag from "../../general/antd/tag";
import moment from "moment";
import { getBannerType, getBannerTypeColor } from "../../../models/banner/enum";
import BannerCategoryContext from "../../../context/banner-category/context";
import Image from "../../general/antd/image";
import styles from './styles.module.scss'
interface IProps { }

const BannerCategoryTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(BannerCategoryContext);

  const columns: ColumnProps<IBanner>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("text"),
      dataIndex: "text",
      align: "center",
      key: "text",
      minWidth:120,
    },
    {
      title: t("image"),
      dataIndex: "image",
      align: "center",
      key: "image",
      render: (_, record) => {
        return (
          <Image
            src={record.image.url}
            preview={true}
          />
        );
      },
    },
    {
      title: t("status"),
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getBooleanStatus(record?.status)}
            color={getUserStatusColor(record?.status)}
          />
        );
      },
    },
    {
      title: t("rateable_type"),
      dataIndex: "rateableType",
      align: "center",
      key: "rateableType",
      render: (_, record) => {
        return (
          <Tag
            title={getBannerType(record?.rateableType)}
            color={getBannerTypeColor(record?.rateableType)}
          />
        );
      },
    },

    {
      title: t("created_at"),
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      minWidth:100,
      render: (createdAt) => {
        return <>{moment(createdAt).format("YYYY-MM-DD")}</>;
      },
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
            onClick={(e) => {
              const url = `/banners-categories/details/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <EditBtn
            onClick={(e) => {
              const url = `/banners-categories/update/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteBanner(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        className={styles.table}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default BannerCategoryTable;
